import React, { useContext } from 'react';
import InputColor from '../inputs/InputColor';
import ExportButton from './ExportButton';
import { ColorContext } from '../../contexts/ColorContext';
import LogoDropdown from '../logoOptions/LogoDropdown';
import { Link } from 'react-router-dom';
import ToggleWatermark from '../logoOptions/ToggleWatermark';
import TemplateButton from './TemplateButton';

const Instructions = () => {
    const { colors } = useContext(ColorContext);
    return ( 
        <div className='instructions'>
            <ol>
                <strong><li>Enter details →</li></strong>
                <br />
                <strong><li>Pick colours</li></strong>
                <InputColor actionType='UPDATE_TEXT_COLOR' label='Text Colour' color={colors.textColor}/>
                <InputColor actionType='UPDATE_BACKGROUND_COLOR' label='Background Colour' color={colors.backgroundColor}/>
                <br /><br />
                <strong><li>Logo options</li></strong>
                <LogoDropdown />
                <br /><br />
                <strong><li>Export background</li></strong>
                <ToggleWatermark /><br/>
                <TemplateButton />
                <ExportButton />
                <br />
                <Link to="/about"><small>About zoomback</small></Link><br />
                <a href="https://support.zoom.us/hc/en-us/articles/210707503-Virtual-Background" target="_blank">
                    <small>How to enable virtual background</small>
                </a>
                <br /><br />
                <a className="bmc-button" target="_blank" href="https://www.buymeacoffee.com/jamesfromldn">
                    <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee"/>
                    <span className="bmc-span">Buy James<br/>a coffee?</span>
                </a>
            </ol>
        </div>
     );
}
 
export default Instructions;
